<template>

  <div class="atividades-preventivaobservacoes ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="6">
                <label for="select-garagem">Garagem</label>  
                <multiselect  v-model="value_garagem" required 
                  :options="garagens" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" name="garagem"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="4">
                   <label for="select-status">Status</label>  

                <multiselect id="selecaostatus" v-model="value_status"  required
                :options="statuss" 
                :multiple="true"                 
                :close-on-select="false" 
                :clear-on-select="true" 
                :preserve-search="true" placeholder="Status" label="status" track-by="status" name="status"
                :preselect-first="false">
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col> 

              <b-col cols="2">
                <br>                 
                <b-button variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,reset()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                </b-button>                      
              </b-col>
          </b-row>
    </b-form>


    <b-col>
      <div >                     
       
       <b-progress class="mt-3 mp-3" :max="barra_limite">
        <b-progress-bar variant="success"  :value="barra_inicial" :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"></b-progress-bar>
      </b-progress>

      </div>
    </b-col>


    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="preventivaobservacoes"  small hover striped sticky-header="870px"  :items="preventivaobservacoes" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="loadCarregaObs(data.item)"    title="Acessar Sac"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="modal-multi-1" cancel-title="Fechar" ok-title="Gravar" @ok="postObs(),reset()"  size="xl" title="SAC - Solicitação.:"   no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>
            <b-row>
              <input  id="id-sac" type="hidden" />
              
              <b-col cols="5">
                <label for="input-live">Tarefa</label> 
                <b-form-input  id="descricao" v-model="preventivaobs.descricao" readonly placeholder=""></b-form-input>
              </b-col>

              <b-col cols="5">
                <label for="input-live">Observações</label>
                <b-form-input id="observacao" v-model="preventivaobs.observacao" readonly placeholder=""></b-form-input>              
              </b-col>

            <b-col cols="5">
              <label for="input-parecer">Status</label> <!-- {{sacsolicitacao.id_status}} {{ `${[this.statuss.filter(a => a.id_status == this.sacsolicitacao.id_status).map(a => a.status)]}`}} -->
              <div>                    
                <b-form-select   id="parecer"               
                  v-model="preventivaobs.id_status"  
                  :options="statuss"
                  class="mb-3 mt-3"
                  text-field="status"                            
                >                
                </b-form-select>
              </div>
            </b-col> 

            </b-row> 
          
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'


export default {    
    name: 'PreventivaObservacao',    

    data: function() {        
      
        return {
            mode: 'save',
            carregando: false,
            atualizando: false,            
            garagem:{}, 
            garagens: [],   // [] lista            
            value_garagem:[],// [] lista     
            
            status:{},
            statuss: [],   // [] lista            
                                     
            preventivaobs:{},// [] lista   
            preventivaobservacoes:[],// [] lista

            
            value_status:'',            
            
            barra_inicial: 0,         
            barra_limite: 60000,

            fields: [
                { key: 'id_filial', label: 'Garagem', sortable: true },  
                { key: 'os_erp', label: 'Nº O.S', sortable: true },     
                { key: 'carro', label: 'Carro', sortable: true },                 
                { key: 'servico', label: 'Serviço', sortable: true },  
                { key: 'id_tarefa', label: 'id_tarefa', sortable: true },  
                { key: 'descricao', label: 'Tarefa', sortable: true },
                { key: 'status', label: 'Status', sortable: true },  
                { key: 'observacao', label: 'Observação', sortable: true },  
                
                { key: 'dt_delegacao', label: 'Data Inicio', sortable: true, formatter: (value, key, preventivaobservacoes) => {
                    return moment(preventivaobservacoes.dt_delegacao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'dt_conclusao', label: 'Data Conclusao', sortable: true, formatter: (value, key, preventivaobservacoes) => {
                    return moment(preventivaobservacoes.dt_conclusao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'dt_leitura_cm', label: 'Data ECM', sortable: true, formatter: (value, key, preventivaobservacoes) => {
                    return moment(preventivaobservacoes.dt_leitura_cm).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },
  
                { key: 'tempo', label: 'Duração', sortable: true },            


                { key: 'executante', label: 'Executante', sortable: true },                 
  

                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {
      

      temporizador() {
      this.handle = setInterval(() =>{
        this.barra_inicial = this.barra_inicial + 1000
        if(this.barra_inicial >= this.barra_limite){
          this.barra_inicial = 0
          this.loadSacSolicitacoes()
        }
      },1000)
      },
      
        loadGaragens() {
          const url = `${baseApiUrl}/manutencao/rfi/garagem`
          axios.get(url).then(res => {
            this.garagens = res.data.map(garagem => {              
              return { id_filial: garagem.id_filial, garagem: garagem.garagem }
            })
          })
        },        

        loadStatus() {
          const url = `${baseApiUrl}/preventiva/observacao/status`
          axios.get(url).then(res => {
            this.statuss = res.data.map(sta => {              
               return { ... sta, value: sta.id_status, status: sta.status }
            })
          })
        },


        loadPreventivaObs() {                        
            let corpo = {    
                "id_filial": `${[this.value_garagem.map(a => a.id_filial)]}`,                
                "id_status": `${[this.value_status.map(r => r.id_status)]}`                
            };
 
            const url = `${baseApiUrl}/preventiva/observacao`            
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.preventivaobservacoes = res.data.map(preventivaobs => {
                            return {                              
                              id_filial: preventivaobs.id_filial, 
                              dt_emissao: preventivaobs.dt_emissao, 
                              id_os: preventivaobs.id_os, 
                              os_erp: preventivaobs.os_erp,
                              carro: preventivaobs.carro, 
                              observacao: preventivaobs.observacao, 
                              id_servico: preventivaobs.id_servico, 
                              servico: preventivaobs.servico, 
                              id_tarefa: preventivaobs.id_tarefa, 
                              descricao: preventivaobs.descricao, 
                              dt_delegacao: preventivaobs.dt_delegacao, 
                              dt_conclusao: preventivaobs.dt_conclusao, 
                              executante: preventivaobs.executante, 
                              id_status: preventivaobs.id_status, 
                              status: preventivaobs.status, 
                              dt_leitura_cm: preventivaobs.dt_leitura_cm, 
                              id_usuario_cm: preventivaobs.id_usuario_cm, 
                              usuario_cm: preventivaobs.usuario_cm, 
                              tempo: preventivaobs.tempo                              
                            }              
                                                })
                        })            
        }, 

        loadCarregaObs(preventivaobs){
            this.preventivaobs = { ...preventivaobs }
        },

        reset() {            
            this.preventivaobs = {}
            this.loadPreventivaObs()
            
        },

        postObs() {                        
        let corpo = {              
                
                "id_os": `${this.preventivaobs.id_os}`,
                "id_tarefa": `${this.preventivaobs.id_tarefa}`,
                "id_status": `${this.preventivaobs.id_status}`
                
        };

        const url = `${baseApiUrl}/jb/preventiva/save`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },
  
    },

    mounted() {                             
      this.temporizador()                  
        this.loadGaragens()  
        this.loadStatus()   
      this.loadPreventivaObs()
        
        //this.loadCarregaObs()      
        
    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#rfilancamentos{   
    font-size: 0.9em;      
    text-align: center;    
}




</style>